<template>
	<div>
		<audio-block-waveform v-if="canShowWaveform" :audioUrl="selectedBlock.data.audio.url"></audio-block-waveform>
	</div>
</template>

<script>
import AudioBlockWaveform from './tracks/AudioBlockWaveform.vue';

export default {
	name: 'BlockTracks',
	inject: ['blocksSelector'],
	components: { AudioBlockWaveform },
	data() {
		return {
			selectedBlock: null,
			selectedBlockState: null
		};
	},
	computed: {
		canShowWaveform() {
			return this.selectedBlock && this.selectedBlock.type === 'audio' && this.selectedBlock.data.audio;
		}
	},
	created() {
		this.blocksSelector.$on(`selection-changed`, ({ block, state }) => {
			this.selectedBlock = block;
			this.selectedBlockState = state;
		});
	}
};
</script>
